var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{ref:"container",attrs:{"id":"container"}},[_c('b-card-text',{staticClass:"mb-2"},[_c('h5',[_vm._v(" "+_vm._s(_vm.$t('pages.voiceAlertSettings.desc'))+" ")])]),_c('text-editor',{key:0,staticClass:"mb-2",attrs:{"id":_vm.newMessage.id,"title":_vm.$t('pages.voiceAlertSettings.newMessage.title'),"desc":_vm.$t('pages.voiceAlertSettings.newMessage.desc'),"param-options":[
        {
          label: 'operator_name_desc',
          value: '{{operatorName}}'
        }
      ]},on:{"update:textEditor":_vm.onUpdateTextEditor,"update:enable":_vm.onUpdateEnable},model:{value:(_vm.newMessage.options),callback:function ($$v) {_vm.$set(_vm.newMessage, "options", $$v)},expression:"newMessage.options"}}),_c('text-editor',{key:1,staticClass:"mb-2",attrs:{"id":_vm.msgWhenOperatorReplyLate.id,"title":_vm.$t('pages.voiceAlertSettings.operatorLateResponse.title'),"desc":_vm.$t('pages.voiceAlertSettings.operatorLateResponse.desc'),"time-notify-desc":_vm.$t('pages.voiceAlertSettings.operatorLateResponse.notify.desc'),"param-options":[
        {
          label: 'operator_name_desc',
          value: '{{operatorName}}'
        },
        {
          label: 'count_unread_desc',
          value: '{{countLateReplyMessage}}'
        },
        {
          label: 'channel_name_desc',
          value: '{{channelName}}'
        }
      ]},on:{"update:textEditor":_vm.onUpdateTextEditor,"update:enable":_vm.onUpdateEnable},model:{value:(_vm.msgWhenOperatorReplyLate.options),callback:function ($$v) {_vm.$set(_vm.msgWhenOperatorReplyLate, "options", $$v)},expression:"msgWhenOperatorReplyLate.options"}}),_c('text-editor',{key:2,staticClass:"mb-2",attrs:{"id":_vm.msgWhenOperatorReplyMissed.id,"title":_vm.$t('pages.voiceAlertSettings.operatorMissedResponse.title'),"desc":_vm.$t('pages.voiceAlertSettings.operatorMissedResponse.desc'),"time-notify-desc":_vm.$t('pages.voiceAlertSettings.operatorMissedResponse.notify.desc'),"param-options":[
        {
          label: 'operator_name_desc',
          value: '{{operatorName}}'
        },
        {
          label: 'count_unread_desc',
          value: '{{countLateReplyMessage}}'
        },
        {
          label: 'channel_name_desc',
          value: '{{channelName}}'
        }
      ]},on:{"update:textEditor":_vm.onUpdateTextEditor,"update:enable":_vm.onUpdateEnable},model:{value:(_vm.msgWhenOperatorReplyMissed.options),callback:function ($$v) {_vm.$set(_vm.msgWhenOperatorReplyMissed, "options", $$v)},expression:"msgWhenOperatorReplyMissed.options"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }